const React = require("react");
const { Routes, Route, Navigate } = require("react-router-dom");
const { CJDropshippingProvider, useCJDropshipping } = require("./context/CJDropshippingContext");
const { DropshippingLayout } = require("./components/DropshippingLayout");
const { DropshippingPlatforms } = require("./pages/DropshippingPlatforms");
const { DropshippingPlatformDetails } = require("./pages/DropshippingPlatformDetails");
const { DropshippingCJConnect } = require("./pages/DropshippingCJConnect");
const { DropshippingCJSignup } = require("./pages/DropshippingCJSignup");
const { DropshippingCategories } = require("./pages/DropshippingCategories");
const { DropshippingSuppliers } = require("./pages/DropshippingSuppliers");
const { DropshippingSupplierProducts } = require("./pages/DropshippingSupplierProducts");
const { DropshippingAllProducts } = require("./pages/DropshippingAllProducts");
const { DropshippingProductDetails } = require("./pages/DropshippingProductDetails");
const { DropshippingImportWizard } = require("./pages/DropshippingImportWizard");
const { DropshippingImportedProducts } = require("./pages/DropshippingImportedProducts");
const { DropshippingOrders } = require("./pages/DropshippingOrders");
const { DropshippingApiErrors } = require("./pages/DropshippingApiErrors");
const { DropshippingSync } = require("./pages/DropshippingSync");
const { DropshippingAdmin } = require("./pages/DropshippingAdmin");
const h = React.createElement;

// Once the seller is actively connected to CJ, the account-creation/signup
// flow no longer applies (see navigation.js) -- redirect direct visits too,
// not just hide the nav link.
const CJSignupRoute = () => {
  const { isCJConnected } = useCJDropshipping();
  return isCJConnected ? h(Navigate, { to: "/dropshipping/connection", replace: true }) : h(DropshippingCJSignup);
};

const FamilyAdminRoute = () => {
  const { isFamily } = useCJDropshipping();
  return isFamily
    ? h(DropshippingAdmin)
    : h(Navigate, { to: "/dropshipping/platforms", replace: true });
};

const CJDropshippingRoutes = () => h(Routes, null,
  h(Route, { element: h(DropshippingLayout) },
    h(Route, { index: true, element: h(Navigate, { to: "platforms", replace: true }) }),
    h(Route, { path: "platforms", element: h(DropshippingPlatforms) }),
    h(Route, { path: "platforms/:platformId", element: h(DropshippingPlatformDetails) }),
    h(Route, { path: "cj", element: h(CJSignupRoute) }),
    h(Route, { path: "cj/signup", element: h(CJSignupRoute) }),
    h(Route, { path: "connection", element: h(DropshippingCJConnect) }),
    h(Route, { path: "categories", element: h(DropshippingCategories) }),
    h(Route, { path: "suppliers", element: h(DropshippingSuppliers) }),
    h(Route, { path: "suppliers/:supplierId/products", element: h(DropshippingSupplierProducts) }),
    h(Route, { path: "products", element: h(DropshippingAllProducts) }),
    h(Route, { path: "products/:productId", element: h(DropshippingProductDetails) }),
    h(Route, { path: "products/:productId/import-wizard", element: h(DropshippingImportWizard) }),
    h(Route, { path: "imported", element: h(DropshippingImportedProducts) }),
    h(Route, { path: "orders", element: h(DropshippingOrders) }),
    h(Route, { path: "errors", element: h(DropshippingApiErrors) }),
    h(Route, { path: "sync", element: h(DropshippingSync) }),
    h(Route, { path: "admin", element: h(FamilyAdminRoute) }),
    h(Route, { path: "*", element: h(Navigate, { to: "platforms", replace: true }) })
  )
);

const CJDropshippingApp = ({ baseUrl, token, userId, translate, roleName, visiblePlatformIds, contentTopRef }) => h(
  CJDropshippingProvider,
  { baseUrl, token, userId, translate, roleName, visiblePlatformIds, contentTopRef },
  h(CJDropshippingRoutes)
);

module.exports = { CJDropshippingApp, CJDropshippingRoutes };
